module.exports = __webpack_public_path__ + "static/envelope-head-de58b762ad369ec7e2e0f0d4383e5dee.png";